import { Requester, } from 'api/utils/Requester';

abstract class BaseRepositoryClass {
    protected requester: Requester;
    protected apiVersion: string;

    constructor({
        requester = new Requester(),
        apiVersion = 'v1',
    } = {}) {
        this.requester = requester;
        this.apiVersion = apiVersion;
    }
}

export default BaseRepositoryClass;
